import { render } from "./Firefighter.vue?vue&type=template&id=6285c6b6"
import script from "./Firefighter.vue?vue&type=script&lang=js"
export * from "./Firefighter.vue?vue&type=script&lang=js"

import "./Firefighter.vue?vue&type=style&index=0&id=6285c6b6&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__